import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

import { Environment } from "../environments/environment";
import * as _ from 'lodash';


class IAccountPreferenceDataList {
  preference: string;
  key: string;
}

interface IPrefs {
  transactionId: string;
  userId: string;
  accountPreferenceDataList: [IAccountPreferenceDataList];
}

interface AccountClosureDates {
  addedPreferences: string;
  removedPreferences: string;
  key: string;
  name: string;
}

@Injectable()
export class PreferenceService {

  private subject = new Subject<any>();

  private accountPreferencesEndpoint: string;
  private accountPrefEmailEndpoint: string;
  private currentEnvironment = this.getCurrentEnvironment();
  private accountPrefsAPIKey: string;
  private oeURL: string;
  splitArray = [] as any
  firstYearStr = [];
  secondYearStr = [];
  thirdYearStr = [];

  constructor(
    private httpClient: HttpClient,
    private environment: Environment
  ) {
    this.accountPreferencesEndpoint = environment.getEnvironmentVariable(
      "accountPreferencesEndpoint"
    );
    this.accountPrefsAPIKey = environment.getEnvironmentVariable(
      "accountPrefsAPIKey"
    );
    this.accountPrefEmailEndpoint = environment.getEnvironmentVariable(
      "accountPrefEmailEndpoint"
    );
    this.oeURL = environment.getEnvironmentVariable("oe_url");
  }


  sendClickEvent() {
    this.subject.next()
  }

  getClickEvent(): Observable<any> {
    return this.subject.asObservable();
  }



  getAccountPrefs(year: string): Observable<any> {
    return this.httpClient.get(
      this.accountPreferencesEndpoint +
      `/v1/accountspreferences/${this.getShipTosFromSessionStorage()}%7C${year}?userid=${this.getUserDataFromSessionStorage().id
      }`,
      this.getHeadersForGetAccountPrefs()
    );
  }




  updateAccountPrefs(
    transactionId: string,
    userId: string,
    preference: string,
    key: string,
    currentYear: string,
    removedClosures,
    addedClosures
  ) {


    const API_UPDATE_PREFS =
      this.accountPreferencesEndpoint + `/v1/accountspreferences`;
    const body = this.buildBodyForUpdateAccountPrefs(
      transactionId,
      userId,
      preference,
      key,
      removedClosures
    );

    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "x-api-key": this.accountPrefsAPIKey,
        Authorization: sessionStorage.getItem("accessToken"),
      }),
      responseType: "text" as "json",
    };
    return this.httpClient.put(API_UPDATE_PREFS, JSON.stringify(body), options);
  }

  updateAccountPrefsWithMultiplePharmacies(
    transactionId: string,
    userId: string,
    preference: string,
    key: any[],
    removedClosures,
    // historyDatesArray
  ) {

    removedClosures = removedClosures.map(i => i + ':R');
    let closureDateData = preference.split(",");
    let finalClosureDates = [];
    closureDateData.forEach((date) => {
      if (date !== "undefined") {
        finalClosureDates.push(date);
      }
    });

    const UPDATE_WITH_MULTI_PHARMACIES =
      this.accountPreferencesEndpoint + `/v1/accountspreferences`;

    const bodyMA = this.createBodyForMultipleAccounts(
      transactionId,
      key,
      userId,
      finalClosureDates.join(),
      removedClosures,
      // historyDatesArray
    );

    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "x-api-key": this.accountPrefsAPIKey,
        Authorization: sessionStorage.getItem("accessToken"),
      }),
      responseType: "text" as "json",
    };

    return this.httpClient.put(
      UPDATE_WITH_MULTI_PHARMACIES,
      JSON.stringify(bodyMA),
      options
    );
  }

  private createBodyForMultipleAccounts(

    transactionId,
    keyAcctsArray,
    userId,
    preferences,
    removedClosures,
    // historyDatesArray
  ) {

    let currentYrs = this.getYears(preferences).filter((v) => v);

    let remClosures = sessionStorage.getItem("removedDates");

    let removedYrs = this.getYears(remClosures);

    let strDates = preferences.split(",");

    let currentYrInRemovedYear = removedYrs.filter(
      (element) => !currentYrs.includes(element)
    );


    let sortedDates;
    if (strDates.length > 1) {
      sortedDates = strDates.sort((a, b) => {
        a = a.split("/");
        b = b.split("/");
        if (a[2] && b[2]) return a[2].localeCompare(b[2]);

      });

    } else {
      sortedDates = strDates;

    }

    let unqiYears = [...new Set(currentYrs)];

    let sortedYear = unqiYears.sort((a, b) => {
      return a.localeCompare(b);

    });

    let numberOfYears = new Set(currentYrs).size;

    let accountPreferenceDataList = [];
    let requestBody = {
      transactionId: transactionId,
      userId: userId,
      accountPreferenceDataList: accountPreferenceDataList,
    };
    let accountPrefs = {};
    let array = new Array(numberOfYears);

    let newArrayWithoutUndefined = [];
    for (let i = 0; i < sortedYear.length; i++) {
      for (let j = 0; j < sortedDates.length; j++) {

        let sDateYear = sortedDates[j].split("/");

        if (sortedYear[i] === sDateYear[2] || (sortedYear[i].concat(':R') === sDateYear[2])) {
          array[i] += "," + sortedDates[j];

        }
      }
    }

    for (let h = 0; h < array.length; h++) {
      newArrayWithoutUndefined[h] = array[h].slice(10);

    }

    for (let j = 0; j < keyAcctsArray.length; j++) {
      for (let i = 0; i < newArrayWithoutUndefined.length; i++) {
        let newRemClosure = removedClosures.filter((v) => v.includes(sortedYear[i]))

        if (sortedYear[i]) {

          accountPrefs = {
            preference: newArrayWithoutUndefined[i].toString(),

            key: keyAcctsArray[j] + "|" + sortedYear[i],
          };
          accountPreferenceDataList.push(accountPrefs);

        }
      }
    }


    if (currentYrInRemovedYear.includes(undefined)) {
      for (let j = 0; j < keyAcctsArray.length; j++) {
        for (let i = 0; i < currentYrInRemovedYear.length; i++) {
          let newRemClosure = removedClosures.filter((v) => v.includes(currentYrInRemovedYear[i]))

          if (currentYrInRemovedYear[i]) {
            accountPrefs = {
              preference: newRemClosure.toString(),
              key: keyAcctsArray[j] + "|" + currentYrInRemovedYear[i],
            };
            accountPreferenceDataList.push(accountPrefs);

          }
        }
      }
    }

    return requestBody;
  }

  buildBodyForUpdateAccountPrefs(
    transactionId,
    userId,
    preferences,
    key,
    removedClosures
  ) {


    let currentYrs = this.getYears(preferences).filter((v) => v);

    let remClosures = sessionStorage.getItem("removedDates");

    let removedYrs = this.getYears(remClosures);

    let strDates = preferences.split(",");

    let currentYrInRemovedYear = removedYrs.filter(
      (element) => !currentYrs.includes(element)
    );

    let sortedDates;
    if (strDates.length > 1) {

      sortedDates = strDates.sort((a, b) => {
        a = a.split("/");
        b = b.split("/");
        if (a[2] && b[2]) return a[2].localeCompare(b[2]);
      });

    } else {
      sortedDates = strDates;

    }

    let unqiYears = [...new Set(currentYrs)];

    let sortedYear = unqiYears.sort((a, b) => {
      return a.localeCompare(b);
    });

    let numberOfYears = new Set(currentYrs).size;

    let accountPreferenceDataList = [];
    let requestBody = {
      transactionId: transactionId,
      userId: userId,
      accountPreferenceDataList: accountPreferenceDataList,
    };
    let accountPrefs = {};
    let array = new Array(numberOfYears);

    let newArrayWithoutUndefined = [];
    for (let i = 0; i < sortedYear.length; i++) {
      for (let j = 0; j < sortedDates.length; j++) {

        let sDateYear = sortedDates[j].split("/");

        if ((sortedYear[i] === sDateYear[2]) || (sortedYear[i].concat(':R') === sDateYear[2])) {
          array[i] += "," + sortedDates[j];

        }
      }
    }


    for (let h = 0; h < array.length; h++) {
      newArrayWithoutUndefined[h] = array[h].slice(10);
    }

    for (let i = 0; i < unqiYears.length; i++) {
      const k = key + "|" + sortedYear[i];
      let newRemClosure = removedClosures.filter((v) => v.includes(unqiYears[i]))
      if (!k.match(/undefined/gi)) {
        accountPrefs = {
          preference: newArrayWithoutUndefined[i].concat("").toString(),
          key: k,

        };
        accountPreferenceDataList[i] = accountPrefs;

      }
    }


    for (let j = 0; j < currentYrInRemovedYear.length; j++) {

      const k = key + "|" + currentYrInRemovedYear[j];
      let newRemClosure = removedClosures.filter((v) => v.includes(currentYrInRemovedYear[j]))

      if (!k.match(/undefined/gi)) {
        accountPrefs = {
          preference: newRemClosure.concat("").toString(),
          key: k,
        };
        accountPreferenceDataList.push(accountPrefs);
      }
    }



    return requestBody;
  }

  //  for (let i = 0; i < unqiYears.length; i++) {

  //   const k = key + "|" + sortedYear[i];

  //   let newRemClosure = removedClosures.filter((v) => v.includes(unqiYears[i]))


  //   if (!k.match(/undefined/gi)) {
  //     accountPrefs = {
  //       preference: newArrayWithoutUndefined[i].concat("," + newRemClosure).toString(),
  //       key: k,
  //     };
  //     accountPreferenceDataList[i] = accountPrefs;

  //   }
  // }

  // for (let j = 0; j < currentYrInRemovedYear.length; j++) {

  //   const k = key + "|" + currentYrInRemovedYear[j];
  //   let newRemClosure = removedClosures.filter((v) => v.includes(currentYrInRemovedYear[j]))

  //   if (!k.match(/undefined/gi)) {
  //     accountPrefs = {
  //       preference: newRemClosure.concat().toString(),
  //       key: k,
  //     };
  //     accountPreferenceDataList.push(accountPrefs);


  //   }
  // }
  countUniqueYears(iterable) {
    return new Set(iterable).size;
  }

  splitClosureDatesByYear(dates) {
    let strDates = dates.split(",");
    let strDays = [];
    let strYears = [];
    strDates.forEach((day) => {
      strDays.push(day.split("/"));
    });
    strDays.forEach((day) => {
      strYears.push(day[2]);
    });

    let sortedDates = strDates.sort((a, b) => {
      a = a.split("/");
      b = b.split("/");
      return a[2].localeCompare(b[2]);
    });

    let unqiYears = [...new Set(strYears)];
    let sortedUniYears = unqiYears.sort((a, b) => {
      return a.localeCompare(b);
    });

    this.buildBody(sortedDates, strYears, sortedUniYears);
  }

  buildBody(sortedDates, strYears, sortedYear) {

    let numberOfYears = this.countUniqueYears(strYears);

    let dc = "9-12334";

    let accountPreferenceDataList = [];
    let accountPrefs = {};
    let array = new Array(numberOfYears);
    let newArrayWithoutUndefined = [];
    for (let i = 0; i < sortedYear.length; i++) {
      for (let j = 0; j < sortedDates.length; j++) {
        let sDateYear = sortedDates[j].split("/");
        if (sortedYear[i] === sDateYear[2]) {
          array[i] += "," + sortedDates[j];
        }
      }
    }
    for (let h = 0; h < array.length; h++) {
      newArrayWithoutUndefined[h] = array[h].slice(10);
    }

    for (let i = 0; i < newArrayWithoutUndefined.length; i++) {
      accountPrefs = {
        preference: newArrayWithoutUndefined[i],
        key: dc + "|" + sortedYear[i],
      };
      accountPreferenceDataList[i] = accountPrefs;

    }
  }

  sendEmailUpdateAccountPrefs(
    transactionId: string,
    userId: string,
    addedPreferences: any,
    removedPreferences: any,
    key: string,
    currentYear: string,
    keyName: string,
    firstName: string,
    email: string
  ): Observable<any> {
    const API_UPDATE_PREFS_EMAIL = this.accountPrefEmailEndpoint;

    let addPrefsArr = addedPreferences.toString();
    let remPrefsArr;

    if (removedPreferences) {
      remPrefsArr = removedPreferences.toString();
    } else {
      remPrefsArr = "";
    }

    let curOEUrl;
    if (this.oeURL === "https://orderexpressdev.cardinalhealth.com") {
      curOEUrl =
        "https://nextgendev.cardinalhealth.com/#/?deeplink=preferences";
    } else if (this.oeURL === "https://orderexpressstg.cardinalhealth.com") {
      curOEUrl =
        "https://nextgenstg.cardinalhealth.com/#/?deeplink=preferences";
    } else {
      curOEUrl = "https://nextgen.cardinalhealth.com/#/?deeplink=preferences";
    }

    let body = {
      transactionId: transactionId,
      userId: userId,
      firstName: firstName,
      email: email,
      link: curOEUrl,
      accountPreferenceDataList: [
        {
          addedPreferences: addPrefsArr,
          removedPreferences: remPrefsArr,
          key: `${key}|2020`,
          name: keyName,
        },
      ],
    };

    addPrefsArr = "";
    remPrefsArr = "";
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "x-api-key": this.accountPrefsAPIKey,
        Authorization: sessionStorage.getItem("accessToken"),
      }),
      responseType: "text" as "json",
    };

    return this.httpClient.put(
      API_UPDATE_PREFS_EMAIL,
      JSON.stringify(body),
      options
    );
  }

  getParamsForGetAccountPrefs(): any {
    return new HttpParams().set(
      "userid",
      this.getUserDataFromSessionStorage().id
    );
  }

  getHeadersForGetAccountPrefs(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: "*/*",
        transactionid: "AccountClosurePreference",
        "x-api-key": this.accountPrefsAPIKey,
        Authorization: sessionStorage.getItem("accessToken"),
        //'Authorization':'eyJhbGciOiJIUzUxMiJ9.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.b1UxLVtwOGdqD_SgPnPIMc9KyDHXzif7gleawfm102lM3xqftPYOV1dmkLFb7plxu5qpb_HkcQF9RtgP1tCIgA'
      }),
    };

    return httpOptions;
  }

  getHeadersForUpdateAccountPrefs(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "x-api-key": this.accountPrefsAPIKey,
        Authorization: sessionStorage.getItem("accessToken"),
        //'Authorization': 'eyJhbGciOiJIUzUxMiJ9.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.xNYAKjD9wgDUlzXzNnFRL6p1nF6XAoyqu_x7aMuEmrd_QZWw4iYeJuFTZVeMTh911Zk3VkUVH1KC3vRi9EyWrQ'
      }),
    };

    return httpOptions;
  }

  getHeadersForEmailUpdateAccountPrefs(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "x-api-key": this.accountPrefsAPIKey,
        Authorization: sessionStorage.getItem("accessToken"),
      }),
    };
    return httpOptions;
  }

  getUserDataFromSessionStorage() {
    return JSON.parse(sessionStorage.getItem("userAPIData"));
  }

  getUserFromAccountPrefsSessionStorage() {
    return sessionStorage.getItem("userDataObjectPref");
  }

  getShipTosFromSessionStorage() {
    let sortedShipTos = JSON.parse(sessionStorage.getItem("sortedShipTos"));
    // let shiptosString = apiData.shipTos[0].id;
    let index;
    let shipToIndex = sessionStorage.getItem("shiptoIndex");
    if (shipToIndex !== null) {
      index = parseInt(shipToIndex);
    } else index = 0;
    let customerId =
      sortedShipTos[shipToIndex].dc + "-" + sortedShipTos[shipToIndex].customer;

    return customerId;
  }

  getCurrentEnvironment(): string {
    return window.location.hostname;
  }

  public clearYearSessionStorage() {
    for (let i = 0; i < sessionStorage.length; i++) {
      let key = sessionStorage.key(i);
      if (
        key !== "accessToken" &&
        key !== "userDataObject" &&
        key !== "userAPIData" &&
        key !== "shiptoIndex" &&
        key !== "shipIoIndex" &&
        key !== "sortedShipTos"
      ) {
        sessionStorage.removeItem(key);
      }
    }
  }

  public getYearSessionStorage() {
    let yrSessionStorageKeys = [];

    for (let i = 0; i < sessionStorage.length; i++) {
      let key = sessionStorage.key(i);
      if (
        key !== "accessToken" &&
        key !== "userDataObject" &&
        key !== "userAPIData" &&
        key !== "shiptoIndex" &&
        key !== "shipIoIndex" &&
        key !== "sortedShipTos" &&
        key !== "removedDates" &&
        key !== "addedDates" &&
        key !== "removedDatesForUpdate"
      ) {
        sessionStorage.getItem(key);
        yrSessionStorageKeys.push(key);
      }
    }

    return yrSessionStorageKeys;
  }

  public getYears(dates) {
    let strYr = [];
    let dateArray = dates.split(",");

    dateArray.forEach((date) => {
      let dateStr = date.split("/");
      if (dateStr.length > 1) {
        strYr.push(dateStr[2].includes(":R") ? dateStr[2].split(":")[0] : dateStr[2]);
      }

    });
    let unqiYears = [...new Set(strYr)];
    return unqiYears;
  }
}